import React, { useEffect, useState } from "react";
import { getLastRead, buildLastReadUrl } from "utils/lastRead";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

export default function LastReadButton({ className = "" }) {
  const [last, setLast] = useState(null);

  // assume state.books.data exists; if your slice has a loading flag, you can use it instead
  const books = useSelector((state) => state.books.data || []);
  const booksLoaded = Array.isArray(books) && books.length > 0;

  useEffect(() => {
    const load = () => {
      const lr = getLastRead();
      if (!lr) {
        setLast(null);
        return;
      }
      // If bookName missing and books are already loaded, resolve it now
      if (!lr.bookName && lr.bookId && booksLoaded) {
        const found = books.find((b) => Number(b.id) === Number(lr.bookId));
        if (found) lr.bookName = found.name;
      }
      setLast(lr);
    };

    load();

    function handleStorage(e) {
      if (e.key === "lastRead") load();
    }
    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, [books, booksLoaded]);

  // No saved last read at all
  if (!last) {
    return (
      <Link
        to="/biblia"
        className={`${className} text-base lg:text-lg text-gray-700 hover:text-gray-900`}
      >
        Ultima lectura
      </Link>
    );
  }

  // If we have a last item but books aren't loaded yet, don't show raw DB id — show a safe label
  if (!last.bookName && !booksLoaded) {
    return (
      <Link
        to="/biblia"
        className={`${className} text-base lg:text-lg text-gray-700 hover:text-gray-900`}
      >
        Ultima lectura
      </Link>
    );
  }

  // If bookName still not found after books loaded, fall back to numeric id (rare)
  const label = last.bookName
    ? `${last.bookName} ${last.chapter}`
    : `${last.bookId} ${last.chapter}`;
  const url = buildLastReadUrl(last);

  return (
    <Link
      to={url}
      className={`${className} text-base lg:text-lg text-gray-700 hover:text-gray-900`}
    >
      <span className="text-xs text-gray-500">Ultima lectura:</span>
      <span className="ml-2 font-medium">{label}</span>
    </Link>
  );
}
